import { PageState, PageStateImage } from '@airwallex/core/dist/page-state';
import Spinner from '@airwallex/core/dist/spinner';
import type { FC } from 'react';

export const PageLoading: FC = (props) => (
  <PageState {...props}>
    <PageStateImage
      center
      width="60px"
      // @ts-ignore
      css={{ height: '100vh', alignItems: 'center' }}
    >
      <Spinner square={60} primary show />
    </PageStateImage>
  </PageState>
);
